import AddProductToWishlistMutation from "./AddProductToWishlistMutation.gql";
import RemoveProductFromWishlistMutation from "./RemoveProductFromWishlistMutation.gql";
import makeCommandDispatcher from "web/core/apollo/makeCommandDispatcher";

const makeAddProductOptions = (props) => {
  const selectedOptions = [];
  for (let option_id in props.selectedOptions) {
    selectedOptions.push({
      option_id,
      option_value: props.selectedOptions[option_id],
    });
  }
  const selectedCustomOptions = [];
  for (let option_id in props.selectedCustomOptions) {
    const option_value = props.selectedCustomOptions[option_id];
    selectedCustomOptions.push({
      option_id,
      option_value: Array.isArray(option_value)
        ? option_value[0]
        : option_value,
    });
  }
  const selectedBundleOptions = [];
  for (let option_id in props.selectedBundleOptions) {
    const { quantity, values } = props.selectedBundleOptions[option_id];
    selectedBundleOptions.push({
      option_id,
      option_value: Array.isArray(values) ? values : [values],
      option_qty: quantity,
    });
  }
  return {
    mutation: AddProductToWishlistMutation,
    variables: {
      sku: props.sku,
      input: {
        selectedOptions,
        selectedCustomOptions,
        selectedBundleOptions,
      },
    },
  };
};

const makeRemoveProductOptions = (props) => ({
  mutation: RemoveProductFromWishlistMutation,
  variables: { itemId: props.wishlistItem.id },
});

export default () =>
  makeCommandDispatcher({
    toggleProductInWishlist: (props) => () => {
      return {
        options: {
          ...(props.isInWishlist
            ? makeRemoveProductOptions(props)
            : makeAddProductOptions(props)),
          refetchQueries: props.shouldRefetchWishlist
            ? ["LoadWishlistQuery"]
            : [],
        },
        callback: (result) => {},
      };
    },
  });
